import './companions.component.scss'

import Swiper, { Navigation } from 'swiper'

import 'swiper/css'
import 'swiper/css/navigation'

class CompanionsGal {
  constructor(main, navigation) {
    this.elements = {
      main,
      navigation
    }

    this.init()
  }

  defineSlider() {
    new Swiper(this.elements.main, {
      modules: [Navigation],
      slidesPerView: 1.5,
      spaceBetween: 8,
      loop: true,
      navigation: this.elements.navigation,
      breakpoints: {
        375: {
          slidesPerView: 2.5,
          spaceBetween: 8,
        },
        667: {
          slidesPerView: 3.5,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 4.5,
          spaceBetween: 24,
        },
        1280: {
          slidesPerView: 5,
          spaceBetween: 24,
        },
        1440: {
          slidesPerView: 6,
          spaceBetween: 24,
          loop: false
        },
      }
    })
  }

  init() {
    this.defineSlider()
  }
}

const companionGalsList = document.querySelectorAll('.companions-gal')
companionGalsList.forEach(slider => {
  new CompanionsGal(slider, {
    prevEl: slider.querySelector('.companions-arrows__arrow-prev'),
    nextEl: slider.querySelector('.companions-arrows__arrow-next')
  })
})